import React from 'react';

interface SchemaOrgProps {
  type: 'localBusiness' | 'service' | 'article' | 'breadcrumb' | 'organization' | 'webpage';
  data?: any;
}

const SchemaOrg: React.FC<SchemaOrgProps> = ({ type, data }) => {
  const generateSchema = () => {
    switch (type) {
      case 'localBusiness':
        return {
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "name": "Construcciones Granada",
          "description": "Empresa constructora y reformas en Granada. Servicio integral a la construcción con obra mayor y menor, estructura, albañilería, fontanería, electricidad y más.",
          "url": "https://constructoragranada.com",
          "logo": "https://constructoragranada.com/CONSTRUCCIONES-GRANADA-LOGO.png",
          "image": "https://constructoragranada.com/image/construccion-en-Granada_construcciones_granada-1536x917.webp",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "La Zubia",
            "addressRegion": "Granada",
            "addressCountry": "ES"
          },
          "telephone": "+34611722282",
          "email": "info@constructoragranada.com",
          "openingHours": [
            "Mo-Fr 08:00-18:00",
            "Sa 09:00-14:00"
          ],
          "priceRange": "€€",
          "areaServed": {
            "@type": "GeoCircle",
            "geoMidpoint": {
              "@type": "GeoCoordinates",
              "latitude": 37.1196,
              "longitude": -3.5847
            },
            "geoRadius": "50000"
          },
          "hasOfferCatalog": {
            "@type": "OfferCatalog",
            "name": "Servicios de Construcción",
            "itemListElement": [
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Obra Nueva",
                  "description": "Construcción de viviendas unifamiliares y promociones"
                }
              },
              {
                "@type": "Offer",
                "itemOffered": {
                  "@type": "Service",
                  "name": "Reformas",
                  "description": "Reformas integrales, cocinas, baños y locales comerciales"
                }
              }
            ]
          },
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.8",
            "reviewCount": "127"
          },
          "sameAs": [
            "https://www.facebook.com/construccionesgranada",
            "https://www.instagram.com/construccionesgranada"
          ],
          "foundingDate": "2007",
          "numberOfEmployees": "15-50",
          "serviceArea": {
            "@type": "GeoCircle",
            "geoMidpoint": {
              "@type": "GeoCoordinates",
              "latitude": 37.1196,
              "longitude": -3.5847
            },
            "geoRadius": "50000"
          }
        };

      case 'service':
        return {
          "@context": "https://schema.org",
          "@type": "Service",
          "name": data?.name || "Servicios de Construcción",
          "description": data?.description || "Servicios integrales de construcción y reformas en Granada",
          "provider": {
            "@type": "LocalBusiness",
            "name": "Construcciones Granada",
            "url": "https://constructoragranada.com"
          },
          "areaServed": {
            "@type": "GeoCircle",
            "geoMidpoint": {
              "@type": "GeoCoordinates",
              "latitude": 37.1196,
              "longitude": -3.5847
            },
            "geoRadius": "50000"
          },
          "serviceType": data?.serviceType || "Construcción y Reformas",
          "category": data?.category || "Construcción",
          "offers": {
            "@type": "Offer",
            "priceCurrency": "EUR",
            "priceSpecification": {
              "@type": "PriceSpecification",
              "price": "0",
              "priceCurrency": "EUR",
              "description": "Presupuesto gratuito"
            }
          }
        };

      case 'article':
        return {
          "@context": "https://schema.org",
          "@type": "BlogPosting",
          "headline": data?.title || "Blog de Construcciones Granada",
          "description": data?.description || "Artículos sobre construcción y reformas en Granada",
          "author": {
            "@type": "Organization",
            "name": "Construcciones Granada",
            "url": "https://constructoragranada.com"
          },
          "publisher": {
            "@type": "Organization",
            "name": "Construcciones Granada",
            "logo": {
              "@type": "ImageObject",
              "url": "https://constructoragranada.com/CONSTRUCCIONES-GRANADA-LOGO.png"
            },
            "url": "https://constructoragranada.com"
          },
          "datePublished": data?.datePublished || new Date().toISOString(),
          "dateModified": data?.dateModified || new Date().toISOString(),
          "mainEntityOfPage": {
            "@type": "WebPage",
            "@id": data?.url || "https://constructoragranada.com/blog"
          },
          "image": data?.image || "https://constructoragranada.com/image/construccion-en-Granada_construcciones_granada-1536x917.webp",
          "articleSection": data?.category || "Construcción",
          "keywords": data?.keywords || "construcción, reformas, granada, obra nueva"
        };

      case 'breadcrumb':
        return {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": data?.items || []
        };

      case 'organization':
        return {
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "Construcciones Granada",
          "url": "https://constructoragranada.com",
          "logo": "https://constructoragranada.com/CONSTRUCCIONES-GRANADA-LOGO.png",
          "description": "Empresa constructora y reformas en Granada",
          "foundingDate": "2007",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "La Zubia",
            "addressRegion": "Granada",
            "addressCountry": "ES"
          },
          "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+34611722282",
            "contactType": "customer service",
            "availableLanguage": "Spanish"
          }
        };

      case 'webpage':
        return {
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": data?.title || "Construcciones Granada",
          "description": data?.description || "Empresa constructora y reformas en Granada",
          "url": data?.url || "https://constructoragranada.com",
          "isPartOf": {
            "@type": "WebSite",
            "name": "Construcciones Granada",
            "url": "https://constructoragranada.com"
          },
          "datePublished": data?.datePublished || "2024-01-01",
          "dateModified": data?.dateModified || new Date().toISOString(),
          "author": {
            "@type": "Organization",
            "name": "Construcciones Granada"
          }
        };

      default:
        return null;
    }
  };

  const schema = generateSchema();
  
  if (!schema) return null;

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(schema)
      }}
    />
  );
};

export default SchemaOrg; 